export default {
  zh: {
    appendadd:'待添加联系人',
    addbyhand:'手动添加的联系人',
    adderror:'请提交后再添加！',
    mustinput:'有必填项未填写！',
    phonterrortips:'请输入10位数字号码！',
    ThaiName: '泰文姓名',
    firstName:'姓名',
    shouru:'收入',
    educalevel:'教育水平',
    childNum:'孩子个数',
    marryState:'婚姻状态',
    title: '客户管理',
    customerList: '客户列表',
    customerDetail: '客户详情',
    mobile: '手机号',
    names: '英文名',
    surnames: '泰文名',
    curpType: '证件类型',
    curp: '证件',
    appName: 'APP名字',
    email: '邮箱',
    description: '描述',
    custName: '客户姓名',
    AadhaarName: 'Aadhaar姓名',
    AadhaarAddress: 'Aadhaar地址',
    AadhaarYears: 'Aadhaar年份',
    AadhaarDate: 'Aadhaar日期',
    AadhaarNo: 'Aadhaar号',
    panName: 'Pan姓名',
    panNo: 'Pan卡号',
    panAddress: 'Pan地址',
    panYears: 'Pan年份',
    panDate: 'Pan日期',
    bankAccountName: '银行账户姓名',
    bankAccountNo: '收款银行账户号',
    collectType: '收款方式',
    birthdayValue:'生日',
    ifscCode: 'IFSC CODE',
    maritalStatus: '婚姻状况',
    numberOfChildren: '供养子女数',
    spouseName: '配偶名称',
    educationLevel: '教育程度',
    monthlyHouseholdIncome: '家庭月收入',
    personalMonthlyIncome: '个人月收入',
    housingType: '住房类型',
    residentialAddress: '居住地址',
    residentialAddressPIN: '居住地址PIN',
    workType: '工作类型',
    workingAddress: '工作地址',
    workingAddressPIN: '工作地址PIN',
    companyName: '公司名称',
    workIndustry: '工作行业',
    workDuty: '工作职务',
    workPosition: '工作职位',
    workYear: '工作年限',
    line: 'line',
    payMethod: '发薪方式',


    handlecontactType:'手动添加的联系人',
    contactType: '联系人类型',
    contactRelationship: '联系人关系',
    contactName: '联系人名称',
    contactPhone: '联系人手机号',
    firstContact: '第一联系人',
    secondContact: '第二联系人',
    thirdContact: '第三联系人',
    fourthContact: '第四联系人',

    aadhaarFront: 'Aadhaar卡正面',
    aadhaarBack: 'Aadhaar卡反面',
    panFront: 'PAN卡照片',
    facePhotoList: '活体检测照片',
    idcardFront: 'ID CARD  -正',
    idcardNegative: 'ID CARD  -反',
    lineqrcode:'line 二维码',
    Utilitybill:'水电单',
    Payslip:'工资单',
    workpermit:'工作证',
    hanldeidcard:'手持id卡',

    fb: 'Facebook',
    creatEmail: 'email',
    createTime: '申请时间',
    OrdersubmissionTime:'订单提交时间',
    reborrowFlag: '复借标识',
    customerBasicInfo: '客户基本信息',
    bankCardInformation: '银行卡信息',
    customerDetailInfo: '客户详细信息',
    customerLinkInfo: '客户联系人信息',
    addcustomerLinkInfo: '添加客户联系人信息',
    customerAadhaarInfo: '客户Aadhaar卡OCR信息',
    customerPanInfo: '客户Pan卡OCR信息',
    customerImageInfo: '客户影像资料',
    age: '年龄',
    channel: '渠道',
    appSsid: '盘号',
    productName: '产品名称',
    epochScore: 'Epoch分',
    modelScore: '模型分',
    customerRiskInfo: '客户风控信息',
    panCardLiveScore: 'PAN卡人脸相似分',
    aadhaarCardLiveScore: 'AADHAAR卡人脸相似分',
    transformingDataExcel: '转化数据导出',
    campaignDataExcel: 'campaign导出',
    channelDataExcel: 'channel导出',
    publisherDataExcel: 'publisher导出',
    setNameDataExcel: 'set_name导出',
    adnameDataExcel: 'ad_name导出',
    dollar3pDataExcel: 'dollar_3p导出',

    payoutId: '放款渠道ID',
    payinId: '还款渠道ID',
    fullName: '客户名称',
    bankName: '收款银行名称',
    excelList: '催收函图片',
    orderImages: '支付凭证',
    cwCode: '银行卡身份证',
    bankCardType: '银行卡类型',

    companyPhone: '公司电话',
    monthlyIncomeScope: '月收入'
  },
  ti: {
    appendadd:'เพิ่มที่อยู่ติดต่อ',
    addbyhand:'เพิ่มที่อยู่ติดต่อด้วยตนเอง',
    adderror:'กรุณาเพิ่มเมื่อส่งแล้ว!',
    mustinput:'ต้องกรอกข้อมูลที่ยังไม่ได้กรอก!',
    phonterrortips:'โปรดใส่หมายเลข 10 หลัก!',
    ThaiName: 'ชื่อไทย',
    firstName:'ชื่อ',
    mobile: 'หมายเลขโทรศัพท์มือถือ',
    shouru:'รายการ',
    educalevel:'ระดับการศึกษา',
    childNum:'จำนวนบุตร',
    marryState:'สถานะการ แต่งงาน',
    firstContact: 'ผู้ติดต่อบุคคลที่ 1',
    secondContact: 'ผู้ติดต่อบุคคลที่ 2',
    thirdContact: 'ผู้ติดต่อบุคคลที่ 3',
    fourthContact: 'ผู้ติดต่อบุคคลที่ 4',
    custName: 'ชื่อ-สกุล ของผู้ขอสินเชื่อ',
    fb: 'Facebook',
    creatEmail: 'email',
    customerImageInfo: 'ข้อมูลรูปภาพลูกค้า',
    createTime: 'เวลาลงทะเบียน',
    OrdersubmissionTime:'เวลาทำรายการสมัครสินเชื่อ',
    payoutId: 'รหัสช่องทางสินเชื่อ',
    bankName: 'ชื่อบัญชีธนาคาร',
    cwCode: 'บัตรธนาคาร บัตรประชาชน',
    bankCardType: 'บัตรออมทรัพย์',
    numberOfChildren: 'จำนวนบุตรบุญธรรม',
    personalMonthlyIncome: 'รายได้ส่วนบุคคลต่อเดือน',
    educationLevel: 'ระดับการศึกษา',
    residentialAddress: 'ที่อยู่',
    workType: 'ประเภทงาน',
    workYear: 'จำนวนปีที่ทำงาน',
    line: 'line',
    maritalStatus: 'สถานภาพสมรส',
    bankAccountNo: 'หมายเลขบัญชีธนาคารของผู้กู้',
    customerBasicInfo: 'ข้อมูลลูกค้าเบื้องต้น',
    bankCardInformation: 'ข้อมูลบัตรธนาคาร',
    names: 'ชื่อภาษาอังกฤษ',
    surnames: 'ชื่อภาษาไทย',
    channel: 'ช่องทาง',
    appSsid: 'หมายเลขดิสก์',
    curp: 'เอกสาร',
    collectType: 'วิธีการชำระเงิน',
    birthdayValue:'วัน เดือน ปี เกิด',
    reborrowFlag: 'สถานะการชำระ',
    customerLinkInfo: 'ข้อมูลการติดต่อลูกค้า',
    addcustomerLinkInfo: 'เพิ่มข้อมูลที่อยู่ติดต่อของลูกค้า',
    contactType: 'ประเภทการติดต่อ',
    handlecontactType:'เพิ่มที่อยู่ติดต่อด้วยตนเอง',
    contactRelationship: 'ติดต่อประชาสัมพันธ์',
    contactName: 'ชื่อผู้ติดต่อ',
    contactPhone: 'หมายเลขโทรศัพท์ติดต่อ',

    aadhaarFront: 'Aadhaarด้านหน้าการ์ด',
    aadhaarBack: 'Aadhaarด้านหลังของการ์ด',
    panFront: 'PANรูปถ่ายการ์ด',
    facePhotoList: 'ภาพถ่ายยืนยันตัวตน',
    idcardFront: 'รูปบัตรประชาชนด้านหน้า',
    idcardNegative: 'รูปบัตรประชาชนด้านหลัง',
    lineqrcode: 'รหัส QR ไลน์',
    Utilitybill: 'ใบแจ้งหนี้ค่าน้ำค่าไฟ',
    Payslip: 'สลิปเงินเดือน',
    workpermit: 'ใบอนุญาตทำงาน',
    hanldeidcard: 'บัตรประชาชนถือในมือ'
  },
  en: {
    appendadd:'Contacts to be added',
    addbyhand:'Manually added contact',
    adderror:'Please submit and then add!',
    mustinput:'There are required items that have not been filled in!',
    phonterrortips:'Please enter a 10 digit number!',
    ThaiName: 'Thai name',
    firstName:'Name',
    shouru:'income',
    educalevel:'Educational level',
    childNum:'Number of children',
    marryState:'Marital status',
    fb: 'Facebook',
    creatEmail: 'email',
    payoutId: 'ID of the lending channel',
    title: 'Customer Management',
    customerList: 'Customer List',
    customerDetail: 'Customer Detail',
    mobile: 'Phone number',
    names: 'English name',
    surnames: 'Thai name',
    curpType: 'curpType',
    curp: 'ID',
    appName: 'App Name',
    custName: 'cust name',
    AadhaarName: 'Aadhaar Name',
    AadhaarAddress: 'Aadhaar Address',
    AadhaarYears: 'Aadhaar Years',
    AadhaarDate: 'Aadhaar Date',
    AadhaarNo: 'Aadhaar Number',
    panName: 'Pan Name',
    panNo: 'Pan Number',
    email: 'Email',
    panAddress: 'Pan Address',
    panYears: 'Pan Years',
    panDate: 'Pan Date',
    bankAccountName: 'BankAccount Name',
    bankAccountNo: 'Recipient bank account number',
    birthdayValue:'Birthday',
    collectType: 'payment method',
    ifscCode: 'IFSC CODE',
    maritalStatus: 'Marital Status',
    numberOfChildren: 'Number of children supported',
    spouseName: 'Spouse Name',
    educationLevel: 'Education Level',
    monthlyHouseholdIncome: 'Monthly Household Income',
    personalMonthlyIncome: 'Personal Monthly Income',
    housingType: 'Housing Type',
    residentialAddress: 'Dirección de residencia',
    residentialAddressPIN: 'Residential Address PIN',
    workType: 'Work Type',
    workingAddress: 'Working Address',
    workingAddressPIN: 'Working Address PIN',
    companyName: 'Company Name',
    workIndustry: 'Work Industry',
    workDuty: 'Work Duty',
    workPosition: 'Work Position',
    workYear: 'Work Year',
    line: 'line',
    payMethod: 'Pay Method',

    contactType: 'Type',
    handlecontactType:'Manually added contact',
    contactRelationship: 'Relationship',
    contactName: 'Contact name',
    contactPhone: 'Phone number',
    firstContact: 'First Contact',
    secondContact: 'Second Contact',

    aadhaarFront: 'Aadhaar Front',
    aadhaarBack: 'Aadhaar Back',
    panFront: 'PAN Front',
    facePhotoList: 'Face Photo',
    OrdersubmissionTime:'Order submission time',
    createTime: 'Registration time',
    reborrowFlag: 'Reborrow Flag',
    customerBasicInfo: 'Customers Basic Information',
    bankCardInformation: 'Bank card information',
    customerDetailInfo: 'Customers Detail Information',
    customerLinkInfo: 'Customers Contact Information',
    addcustomerLinkInfo: 'Add customer contact information',
    customerAadhaarInfo: 'Customers Aadhaar‘s OCR Information',
    customerPanInfo: 'Customers Pan‘s OCR Information',
    customerImageInfo: 'Customer Image Data',
    age: 'Edad',
    channel: 'Channel',
    appSsid: 'appSsid',
    productName: 'Product Name',
    epochScore: 'Epoch Score',
    modelScore: 'Model Score',
    customerRiskInfo: 'Customer Risk Info',
    panCardLiveScore: 'PAN CARD FACE SCORE',
    aadhaarCardLiveScore: 'AADHAAR FACE SCORE',

    stpAccount: 'stp',
    fullName: 'Full name',
    bankName: 'Bank Name',
    cwCode: 'Bank card ID card',
    bankCardType: 'Bank card type',
    excelList: ' Download loan information images ',
    orderImages: 'Up payment voucher ',

    companyPhone: 'Company Office Number',
    monthlyIncomeScope: 'monthly income',
    description: 'description',

    idcardFront: 'ID CARD-positive',
    idcardNegative: 'ID CARD-inverse',

    lineqrcode: 'Line QR Code',
    Utilitybill: 'Utility Bill',
    Payslip: 'Payslip',
    workpermit: 'Work Permit',
    hanldeidcard: 'ID Card Held'
  },
  es: {
    title: 'Customer Management',
    customerList: 'Customer List',
    customerDetail: 'Customer Detail',
    mobile: 'Phone number',
    names: 'Nombre en inglés',
    surnames: 'Nombre tailandés',
    curpType: 'curpType',
    curp: 'Documento de identidad',
    appName: 'App Name',
    custName: 'cust name',
    AadhaarName: 'Aadhaar Name',
    AadhaarAddress: 'Aadhaar Address',
    AadhaarYears: 'Aadhaar Years',
    AadhaarDate: 'Aadhaar Date',
    AadhaarNo: 'Aadhaar Number',
    panName: 'Pan Name',
    panNo: 'Pan Number',
    email: 'Email',
    panAddress: 'Pan Address',
    panYears: 'Pan Years',
    panDate: 'Pan Date',
    bankAccountName: 'BankAccount Name',
    bankAccountNo: 'Número de cuenta del banco receptor',
    collectType: 'Forma de recibir préstamo',
    ifscCode: 'IFSC CODE',
    maritalStatus: 'Marital Status',
    numberOfChildren: 'Número de hijos a cargo',
    spouseName: 'Spouse Name',
    educationLevel: 'Education Level',
    monthlyHouseholdIncome: 'Monthly Household Income',
    personalMonthlyIncome: 'Personal Monthly Income',
    housingType: 'Housing Type',
    residentialAddress: 'Dirección de residencia',
    residentialAddressPIN: 'Residential Address PIN',
    workType: 'Work Type',
    workingAddress: 'Working Address',
    workingAddressPIN: 'Working Address PIN',
    companyName: 'Company Name',
    workIndustry: 'Work Industry',
    workDuty: 'Work Duty',
    workPosition: 'Work Position',
    line: 'line',
    payMethod: 'Pay Method',

    contactType: 'Tipo de contacto',
    contactRelationship: 'Relación del contacto',
    contactName: 'Nombre del contacto',
    contactPhone: 'Número de teléfono del contacto',
    firstContact: 'Primer contacto',
    secondContact: 'Segundo contacto',

    aadhaarFront: 'Aadhaar Front',
    aadhaarBack: 'Aadhaar Back',
    panFront: 'PAN Front',
    facePhotoList: 'Fotos de deteción en vivo',

    createTime: 'Fecha de creación',
    reborrowFlag: 'Marca de repetición de préstamo',
    customerBasicInfo: 'Información básica del cliente',
    bankCardInformation: 'Información de la tarjeta bancaria',
    customerDetailInfo: 'Customers Detail Information',
    customerLinkInfo: 'Información de contacto del usuario',
    customerAadhaarInfo: 'Customers Aadhaar‘s OCR Information',
    customerPanInfo: 'Customers Pan‘s OCR Information',
    customerImageInfo: 'imágenes de usuario',
    age: 'Edad',
    channel: 'Channel',
    appSsid: 'Número de disco',
    productName: 'Product Name',
    epochScore: 'Epoch Score',
    modelScore: 'Model Score',
    customerRiskInfo: 'Customer Risk Info',
    panCardLiveScore: 'PAN CARD FACE SCORE',
    aadhaarCardLiveScore: 'AADHAAR FACE SCORE',

    payoutId: 'ID del canal de dar préstamo',
    stpAccount: 'stp',
    fullName: 'Full name',
    bankName: 'Nombre del banco receptor',
    cwCode: 'Tarjeta bancaria DNI',
    bankCardType: 'Tipo de tarjeta bancaria',
    excelList: ' Download loan information images ',
    orderImages: 'Up payment voucher ',

    companyPhone: 'Company Office Number',
    monthlyIncomeScope: 'monthly income',
    description: 'description'
  }
}